module.exports = {
  INTERNAL: {
    BUTTON_LOADED: 'buttonLoaded',
    CONTINUE: 'payments.continue',
    FINISHED: 'payments.finished',
    SELECTED: 'payments.selected',
    HOSTED_FIELD_REQUEST_RECEIVED: 'hostedFields.messageReceived',
    CCA_REQUEST_RECEIVED: 'cca.messageReceived',
    DF_REQUEST_RECEIVED: 'df.messageReceived',
    DF_BROWSER_PROFILING_COMPLETED: 'df.browserProfilingCompleted',
    DF_BIN_PROFILING_COMPLETED: 'df.binProfilingCompleted'
  },
  ACCOUNT_NUMBER_UPDATE: 'accountNumber.update',
  BIN_PROCESS: 'bin.process',
  CANCELED: 'payments.canceled',
  CONFIGURE: 'configure.',
  CONTINUE: 'continue.',
  COMPLETED: 'payments.completed',
  FARNSWORTH_GIVE_NEWS: 'farnsworth.giveNews',
  HOSTED_FIELD_VALID: 'hostedField.valid',
  HOSTED_FIELD_VALIDATION_ERROR: 'hostedField.validationError',
  JWT_CREATED: 'jwt.created',
  JWT_UPDATE: 'jwt.update',
  METRICS_NOTIFY: 'metrics.notify',
  ORDER_CREATE: 'order.create',
  ORDER_PARSE: 'order.parse',
  ORDER_UPDATE: 'order.update',  
  REDIRECTING: 'payments.redirecting',
  SETUP_COMPLETE: 'payments.setupComplete',
  START: 'start.',
  UI_CLOSE: 'ui.close',
  UI_INLINE_SETUP: 'ui.inline.setup',
  UI_LOADING_RENDER: 'ui.loading.render',
  UI_LOADING_CLOSE: 'ui.loading.close',
  UI_RENDER: 'ui.render',
  UI_RENDER_HIDDEN: 'ui.renderHidden',
  VALIDATED: 'payments.validated'
};


//////////////////
// WEBPACK FOOTER
// ./constants/events.js
// module id = 51
// module chunks = 0 5 20